import React from 'react';
import './styles.css';
import {Link} from "react-router-dom";


class NewsItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            newsList: null
        }

        this.initNews();
    }

    render() {

        return (

            <div>

                {
                    this.state.loading &&
                    <p>Loading news...</p>
                }

                {
                    this.state.newsList != null && this.state.newsList.length > 0 &&
                    <div className={`newsContainer`}>
                        {
                            this.state.newsList.map((newItem, index) =>
                                <NewItem
                                    key={newItem.id}
                                    newItem={newItem}/>
                            )
                        }
                    </div>
                }


            </div>
        );
    }

    initNews() {
        this.state.loading = false;
        this.state.newsList = [{
            id: 1,
            title: "First new",
            description: 'new Descrption'
        },
            {
                id: 2,
                title: 'Second title',
                description: 'another description'
            }
        ]
    }
}


export default NewsItem;


class NewItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newItem: props.newItem
        }
    }

    render() {
        return (
            <Link to={`/news/` + this.state.newItem.id}>
                <div className={`newItem`}>
                    <p className={`newTitle`}>{this.state.newItem.title}</p>
                </div>
            </Link>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/NewsList/index.js